import {
  GetCorpHeroComponentDocument,
  GetCorpHeroComponentQuery,
  GetCorpHeroComponentQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getCorpHeroComponent(id: string, locale: string) {
  return client.query<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>({
    query: GetCorpHeroComponentDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
